import { useMemo } from 'react';
import { useGetEmployeeFormOptions } from '@/employees/application/adapters/getEmployeeFormOptions';

const SUPPORTED_RAPTOR_JOB_ROLES = [1, 2, 3];

export const OPERATOR_ROLE = {
  id: 1,
  name: 'Operator'
} as const;

/**
 * Hook to get job roles for ERP jobs
 * Filters job roles to only include roles with IDs: 1, 2, 3
 * @returns Object containing jobRoles (all roles), supportedJobRoles (filtered roles), and loadingJobRoles boolean
 */
export const useJobRoles = () => {
  const { availableJobRoles: jobRoles, loading: loadingJobRoles } = useGetEmployeeFormOptions({ skip: false });

  const supportedJobRoles = useMemo(() => jobRoles?.filter((role) => SUPPORTED_RAPTOR_JOB_ROLES.includes(role.id)) ?? [], [jobRoles]);

  return {
    jobRoles,
    supportedJobRoles,
    loadingJobRoles
  };
};
